export const VisaRouting = [
  {
    path: "/contract/visa/list",
    name: "contract-visa-list",
    meta: { title: "甲方签证管理" },
    component: () =>
      import(/* webpackChunkName: "contract-visa" */ "@/views/contract/visa/list/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/visa/create",
    name: "contract-visa-create",
    meta: { title: "新增甲方签证", comName:"ContractVisaFormCreate"},
    component: () =>
      import(/* webpackChunkName: "contract-visa" */ "@/views/contract/visa/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/visa/edit/:id",
    name: "contract-visa-edit",
    meta: { title: "编辑甲方签证", comName:"ContractVisaFormCreate" },
    component: () =>
      import(/* webpackChunkName: "contract-visa" */ "@/views/contract/visa/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/visa/detail/:id",
    name: "contract-visa-detail",
    meta: { title: "甲方签证详情" },
    component: () =>
      import(/* webpackChunkName: "contract-visa" */ "@/views/contract/visa/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/visa/flowPrint/:id",
    name: "contract-visa-flow-print",
    meta: { title: "打印甲方签证" },
    component: () =>
      import( /* webpackChunkName: "contract-visa" */ "@/views/contract/visa/flow-print/index.vue"),
  },
];
